// The render pages' typefaces from the designer's Figma (3DWay › Advertising_web_last,
// 2026-09-22): Outfit for display text, Manrope for everything else. Requested on demand, like
// the discover topbar does for Manrope, because the pages are flag-gated (dev only) and the
// rest of the app must not pay for the fonts. Manrope from 300: the profile menu's email is Light.
const LINK_ID = 'render-landing-fonts';
const HREF = 'https://fonts.googleapis.com/css2?family=Manrope:wght@300..800&family=Outfit:wght@500;700&display=swap';

// The landing's IBM Plex Mono labels, IBM Plex Sans for its episode numbers, and Outfit 600 for the
// profile ring's letter, which the flow shows too.
const V2_LINK_ID = 'render-v2-fonts';
const V2_HREF = 'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&family=IBM+Plex+Sans:wght@400&family=Outfit:wght@600&display=swap';

export function ensureRenderFontsLoaded(document: Document): void {
  addStylesheet(document, LINK_ID, HREF);
  addStylesheet(document, V2_LINK_ID, V2_HREF);
}

function addStylesheet(document: Document, id: string, href: string): void {
  if (document.getElementById(id)) {
    return;
  }

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}
